import {
  ComboForm,
  MenuConfigurationTab,
  ModifierForm,
  ModifierGroupForm,
} from './types';

export const MENU_CONFIGURATION_TABS: Array<{
  value: MenuConfigurationTab;
  label: string;
}> = [
  { value: 'MODIFIERS', label: 'Modificadores' },
  { value: 'ASSIGNMENTS', label: 'Asignaciones' },
  { value: 'COMBOS', label: 'Combos' },
];

export const EMPTY_MODIFIER_GROUP: ModifierGroupForm = {
  id: 0,
  name: '',
  description: '',
  minSelections: 0,
  maxSelections: 1,
  required: false,
  displayOrder: 0,
  active: true,
};

export const EMPTY_MODIFIER: ModifierForm = {
  id: 0,
  groupId: 0,
  name: '',
  priceAdjustment: 0,
  deductRawMaterial: false,
  rawMaterialId: '',
  consumptionQuantity: '',
  consumptionUnitId: '',
  displayOrder: 0,
  active: true,
};

export const EMPTY_COMBO: ComboForm = {
  id: 0,
  code: '',
  name: '',
  description: '',
  price: 0,
  available: true,
  displayOrder: 0,
  active: true,
  items: [],
};

export const MENU_CONFIGURATION_FIELD_CLASS =
  'w-full rounded-xl border border-stroke bg-transparent px-3.5 py-2.5 text-sm text-black outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/10 dark:border-strokedark dark:text-white';
